import { jsx } from "react/jsx-runtime";
const CheckCircleIcon = (props) => /* @__PURE__ */ jsx("svg", { ...props, viewBox: "0 0 1024 1024", children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512 64C264.6 64 64 264.6 64 512C64 759.4 264.6 960 512 960C759.4 960 960 759.4 960 512C960 264.6 759.4 64 512 64ZM737.59 374.627C740.329 371.16 739.738 366.129 736.271 363.39L686.046 323.722C682.579 320.984 677.548 321.575 674.81 325.042L462.289 597.755L365.535 474.918C362.799 471.448 357.768 470.854 354.299 473.59L304.046 513.222C300.577 515.958 299.983 520.988 302.719 524.457L430.073 686.095L430.074 686.097C446.481 707.898 478.017 707.912 494.441 686.118L737.59 374.627Z"
  }
) });
export {
  CheckCircleIcon
};
